import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconList } from 'components/Icon';
import "./FloatMenu.css";
import hamburger from 'assets/svgicon/icon-hamburger.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { TEXT_MANAGEMENT_SETTING, TEXT_MASTER_MANAGEMENT, TEXT_SENSOR_FLOOD, TEXT_SENSOR_FLOOD_GATE, TEXT_SENSOR_CAMERA, TEXT_SENSOR_LIST, TEXT_SENSOR_MANAGEMENT, TEXT_SENSOR_MAP, TEXT_USER_MANAGEMENT, TEXT_SENSOR_GENERAL } from 'constants/message';
import { AccountType } from 'models';
import { PAGE_FLOOD_GATE_SENSOR_LIST, PAGE_FLOOD_SENSOR_LIST, PAGE_CAMERA_SENSOR_LIST, PAGE_SENSOR_MANAGEMENT, PAGE_MAP, PAGE_MASTER_MANAGEMENT, PAGE_PROFILE, PAGE_USER_MANAGEMENT, PAGE_GENERAL_SENSOR_LIST } from 'utils/constanst';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { logoutCognitoUser } from 'apis/UserApi';

const MENU_ITEMS = [
  {
    id: 'separator-1',
    separator: true,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: 'header-1',
    header: TEXT_SENSOR_MANAGEMENT,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_MAP,
    icon: IconList.iconMenuMap,
    text: TEXT_SENSOR_MAP,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN]
  },
  {
    id: PAGE_FLOOD_SENSOR_LIST + '_' + PAGE_FLOOD_GATE_SENSOR_LIST, // control submenu
    icon: IconList.iconMenuSensorDetail,
    text: TEXT_SENSOR_LIST,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
    children: [
      {
        id: PAGE_CAMERA_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_CAMERA,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
      {
        id: PAGE_FLOOD_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_FLOOD,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN]
      },
      {
        id: PAGE_FLOOD_GATE_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_FLOOD_GATE,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
      {
        id: PAGE_GENERAL_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_GENERAL,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
    ]
  },
  {
    id: 'separator-2',
    separator: true,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: 'header-2',
    header: TEXT_MANAGEMENT_SETTING,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_SENSOR_MANAGEMENT,
    icon: IconList.iconMenuSensorManage,
    text: TEXT_SENSOR_MANAGEMENT,
    owners: [AccountType.MANAGER, AccountType.ADMIN],

  },
  {
    id: PAGE_USER_MANAGEMENT,
    icon: IconList.iconMenuUser,
    text: TEXT_USER_MANAGEMENT,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_MASTER_MANAGEMENT,
    icon: IconList.iconMenuMaster,
    text: TEXT_MASTER_MANAGEMENT,
    owners: [AccountType.ADMIN],
  }
]

const propTypes = {
  selectedItem: PropTypes.number,
  onClickItem: PropTypes.func
};
const defaultProps = {};
const FloatMenu = (props) => {
  /*** States and Variables ***/
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useAuth();
  const menuRef = React.useRef(null);
  const [openStates, setOpenStates] = React.useState([]);
  /*** Processing ***/
  const logOut = async () => {
    try {
      await logoutCognitoUser();
      setCurrentUser(null);
      navigate("/login");
    } catch (e) {
      console.error(e)
    }
  }
  /*** Sub Components ***/
  const renderMenuItem = (item, level = 1) => {
    if (item.owners.includes(currentUser?.accountType)) {
      if (item.separator) {
        return <div key={item.id} className='float_menu_separator' />
      }
      if (item.header) {
        return <div key={item.id} className='float_menu_group_header'>
          {item.header}
        </div>
      }
      return <>
        <div
          key={item.text}
          onClick={() => { onClickItem(item) }}
          className={props.selectedItem === item.id ? 'float_menu_menu_item_selected' : 'float_menu_menu_item'}
          style={{
            paddingLeft: `${14 * level}px`
          }}>
          <div className='float_menu_menu_item_left_side'>
            <Icon icon={item.icon} />
            <label className='float_menu_menu_item_text'>{item.text}</label>
          </div>
          {item.children &&
            <FontAwesomeIcon
              icon={faChevronRight}
              className={openStates.includes(item.id) ? 'float_menu_up_arrow' : 'float_menu_down_arrow'} />}
        </div>
        {item.children &&
          <div
            className='float_menu_submenu_container'
            style={{
              maxHeight: `${openStates.includes(item.id) ? 72 * item.children.length : 0}px`
            }}>
            {item.children.map(child => renderMenuItem(child, level + 1))}
          </div>}
      </>;
    }
    return null;
  }
  /*** Event Handlers ***/
  const onClickItem = (item) => {
    if (item.children) {
      if (openStates.includes(item.id)) {
        setOpenStates(openStates.filter(s => s !== item.id));
      }
      else {
        openStates.push(item.id);
        setOpenStates(Object.assign([], openStates));
      }
    }
    else if (item.id) {
      props.onClickItem(item.id);
      setIsOpen(false);
    }
  }
  const onBlur = (e) => {
    if (!menuRef.current.contains(e.relatedTarget)) {
      setIsOpen(false);
    }
  }
  /*** Main Render ***/
  return <div
    className='float_menu_anchor'
    tabIndex={100}
    ref={menuRef}
    onBlur={onBlur}>
    <button
      className='float_menu_menu_button'
      onClick={() => { setIsOpen(prev => !prev) }}>
      <img
        src={hamburger}
        alt='menu'
        className='float_menu_menu_button_icon' />
      <p className='float_menu_menu_button_text'>メニュー</p>
    </button>
    <div
      className='float_menu_menu_container'
      style={{
        display: isOpen ? 'block' : 'none'
      }}>
      <div
        className='float_menu_menu_item'
        onClick={() => { setIsOpen(false); props.onClickItem(PAGE_PROFILE) }}>
        <div className='float_menu_menu_item_left_side'>
          <Icon icon={IconList.iconUser} />
          <label className='float_menu_menu_item_text'>{currentUser?.name || ''}</label>
        </div>
      </div>
      {
        MENU_ITEMS.map((item) => renderMenuItem(item))
      }
      <div className='float_menu_separator' />
      <div
        className='float_menu_menu_item'
        onClick={logOut}>
        <div className='float_menu_menu_item_left_side'>
          <Icon icon={IconList.iconMenuLogout} />
          <label className='float_menu_menu_item_text'>ログアウト</label>
        </div>
      </div>
    </div>
  </div>;
}
FloatMenu.propTypes = propTypes;
FloatMenu.defaultProps = defaultProps;
export default FloatMenu;